import oget from 'oget';
import sortBy from 'lodash.sortby';
import parseHeat from './parse-heat';
import contestActiveStates from './contestActiveStates';

const parseContests = ({
  contestsData,
  liveData = [],

  selectedContestId,
  selectedRoundId,
  selectedHeatId,
}) => {
  let selectedRoundIndex = null;

  const contestsByExternalId = {};
  const contests = sortBy(contestsData, 'name');
  const { contestsActiveId, roundActiveId } = contestActiveStates.get(contests);
  contests.map((contest) => {
    if (!selectedContestId && contest.externalId === contestsActiveId) {
      selectedContestId = contest.externalId;
    }

    contest.rounds = sortBy(contest.rounds, 'order').map((round, i) => {
      if (!selectedRoundId && round.externalId === roundActiveId) {
        selectedRoundId = round.externalId;
      }

      round.heats = round.heats.map((heat = {}) => {
        const { externalId: contestId } = contest;
        const { externalId: roundId } = round;
        const { externalId: heatId } = heat;

        const liveHeat = oget(liveData, `${contestId}.${roundId}.${heatId}`);

        const updatedHeat = liveHeat && liveHeat.updated !== heat.updated ? liveHeat : heat;

        return parseHeat(round.type, updatedHeat);
      });

      round.heats = sortBy(round.heats, 'order');

      const liveHeat = round.heats.reduce((liveHeat, heat = {}) => {
        const { athletesById } = heat;

        if (!athletesById || liveHeat) {
          return liveHeat;
        }

        const liveAthletes = Object.keys(athletesById).filter(
          (externalAthleteId) => athletesById[externalAthleteId].isLive,
        );

        if (liveAthletes.length) {
          return heat;
        }

        return liveHeat;
      }, undefined);

      round.liveHeat = liveHeat || round.heats[0];

      if (selectedRoundId === round.externalId) {
        selectedRoundIndex = i;
      }

      return round;
    });

    contestsByExternalId[contest.externalId] = contest;
    return contest;
  });

  if (!selectedContestId) {
    selectedContestId = oget(contests, `[${contests.length - 1}].externalId`);
  }

  const selectedContest = oget(contestsByExternalId, selectedContestId, {});

  if (!selectedRoundId) {
    selectedRoundIndex = oget(selectedContest, 'rounds.length', 0) - 1;

    selectedRoundId = oget(selectedContest, `rounds[${selectedRoundIndex}].externalId`);
  }

  if (!selectedHeatId) {
    selectedHeatId = oget(selectedContest, `rounds[${selectedRoundIndex}].liveHeat.externalId`);
  }

  return {
    contests,
    contestsByExternalId,
    selectedContestId,
    selectedRoundId,
    selectedHeatId,
  };
};

export default parseContests;
